import { useState } from 'react'
import { type FieldError, type FieldValues, useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'

import { Alert, AlertIcon } from '@chakra-ui/react'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

import MainButton from '../../components/Button/MainButton'
import GenericHeader from '../../components/header/GenericHeader'
import { API_URL } from '../../components/helpers/Helpers'
import CustomInput from '../../components/inputs/CustomInput'
import Wrapper from '../../components/wrapper/Wrapper'

import type { AlertStatus } from '../RequestRemoveAccount'

const RemoveAccount = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<FieldValues>({
    defaultValues: { code: '' },
    resolver: yupResolver(
      yup.object().shape({
        code: yup.string().required('Código obrigatório').length(5, 'Código inválido'),
      }),
    ),
  })
  const { key } = useParams()
  const [alertStatus, setAlertStatus] = useState<AlertStatus>('error')
  const [messageAlert, setMessageAlert] = useState('')
  const [showInput, setShowInput] = useState(true)

  function submit(data: FieldValues) {
    fetch(`${API_URL}/auth/account/exclude-account`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: data.code,
        key,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.ok) {
          if (data.error.message === 'Token inválido') {
            setAlertStatus('error')
            setMessageAlert('Código inválido')
          } else {
            setMessageAlert(data.error.message)
          }
          setTimeout(() => {
            setMessageAlert('')
          }, 2000)
        }

        if (data.ok) {
          setAlertStatus('success')
          setMessageAlert('Conta excluída com sucesso')
          setShowInput(false)
        }
      })
  }

  return (
    <Wrapper opacity={'1'}>
      {messageAlert && (
        <Alert status={alertStatus}>
          <AlertIcon />
          {messageAlert}
        </Alert>
      )}
      {showInput && (
        <div>
          <GenericHeader />
          <form
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: '30px',
            }}
          >
            <CustomInput
              title="Informe o código de verificação enviado para seu e-mail"
              register={register}
              value={watch('code')}
              name="code"
              error={errors.code as FieldError}
            />

            <MainButton type="submit" text="Excluir" justifyButton={'center'} onClick={handleSubmit(submit)} />
          </form>
        </div>
      )}
    </Wrapper>
  )
}

export default RemoveAccount
